<template>
    <section class="documentation philatelie">
        <div class="container">
            <slot name="titre"></slot>

            <section class="filters">
                <div class="wrap-head-filters">
                    <ul class="filtre-taaf-rnn">
                        <li><a href="" :class="{active : !archives}" @click.prevent="switchPage(false)">
                            <slot name="catalogLabel"></slot>
                        </a></li>
                        <li><a href="" :class="{active : archives}" @click.prevent="switchPage(true)">
                            <slot name="archiveLabel"></slot>
                        </a></li>
                    </ul>
                    <div class="custom-select-year" v-if="archives">
                        <p>De :</p>
                        <custom-select :options="startListYear" v-model="startYear"
                                       @change="updateSelect('from')"></custom-select>
                    </div>
                    <div class="custom-select-year" v-if="archives">
                        <p>à :</p>
                        <custom-select :options="endListYear" v-model="endYear"
                                       @change="updateSelect()"></custom-select>
                    </div>
                </div>
            </section>

            <div class="loader-wrap" v-if="loading">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <div class="navigation-wrapper">
                <i class="icon-arrow-right prev" @click="previousPage()" v-if="showPrev"></i>
                <i class="icon-arrow-right next" @click="nextPage()" v-if="showNext"></i>

                <transition-group
                        tag="div"
                        class="list-wrap"
                        v-bind:css="false"
                        v-on:before-enter="beforeEnter"
                        v-on:enter="enter"
                >
                    <article class="one-stamp"
                             :key="'key_'+index"
                             :data-index="index"
                             v-for="(item,index) in result">

                        <div class="stamp-wrap">
                            <a :href="item.imgUrlFull" data-fancybox="">
                                <img :src="item.imgUrlPreview" alt="">
                            </a>
                        </div>
                        <div class="infos">
                            <h3 class="titre vert" v-html="item.title"></h3>
                            <p class="collection" v-html="item.collection"></p>
                            <p class="type-timbre" v-html="item.type"></p>
                            <p class="format" v-html="item.format"></p>
                            <p class="valeur" v-html="item.valeur"></p>
                        </div>

                    </article>
                </transition-group>
                <p v-if="result && result.length === 0" class="no-results">
                    <slot name="no-results"></slot>
                </p>
            </div>

            <pagination
                    v-if="!loading && showPagination"
                    :pagination="pagination"
                    :params="form"
                    :offset="2"
                    @paginate="formSubmit"></pagination>

        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"
    import {sortBy} from "lodash"

    export default {
        mixins: [Ajax, Animation],
        props: {
            years: {
                type: Array,
            }
        },
        data() {
            return {
                result: null,
                loading: false,
                pagination: {},
                firstLoad: true,
                form: {
                    page: 1,
                },
                showLinksWrap: false,
                startYear: null,
                endYear: null,
                startListYear: null,
                endListYear: null,
                archives: false
            };
        },
        computed: {
            showPrev() {
                return this.pagination.current_page !== 1
            },
            showNext() {
                return this.pagination.current_page !== this.pagination.last_page
            },
            showPagination() {
                if ((this.pagination.current_page === this.pagination.last_page) && this.pagination.current_page === 1) {
                    return false
                } else {
                    return true
                }
            }
        },
        methods: {
            formSubmit(form) {
                this.loading = true;
                this.result = null;
                if (form) {
                    this.form = form;
                }
                if (!this.form.page) {
                    this.form.page = 1;
                }

                if (!this.firstLoad) {
                    Scrolling.scrollTo(".list-wrap", "easeOutCubic", 600, 200);

                }

                this.ajax("philatelie", "getCatalog", {form: this.form}).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.pagination = data.pagination;
                        this.$nextTick(() => {
                            this.result = data.result;
                        })
                        this.firstLoad = false

                    } else {
                        console.log("error");
                    }
                });


            },
            filtreSite(taxoId) {
                this.form.taxoId = taxoId
                this.formSubmit()
            },
            getResume(item) {
                let link = "<a href=\"" + item.url + "\" class=\"more\">— Voir</a>";
                return item.summary_html + " " + link
            },
            previousPage() {
                if (this.pagination.current_page === 1) {
                    return
                }
                this.form.page = this.form.page - 1
                this.formSubmit()

            },
            nextPage() {
                if (this.pagination.current_page === this.pagination.last_page) {
                    return
                }
                this.form.page = this.form.page + 1
                this.formSubmit()
            },
            updateSelect(target) {
                if (this.endYear.value <= this.startYear.value) {
                    if (target === "from") {
                        this.endYear = this.startYear
                    } else {
                        this.startYear = this.endYear
                    }
                }

                this.form.page = 1
                this.form.startYear = this.startYear.value
                this.form.endYear = this.endYear.value
                this.formSubmit()
            },
            initYears() {
                this.startListYear = sortBy(this.years, ["value"]);

                this.endListYear = this.startListYear.slice().reverse()
                // this.endListYear = [...this.startListYear].reverse()

                this.startYear = this.startListYear[0]
                this.endYear = this.endListYear[0]


                this.form.startYear = this.startYear.value
                this.form.endYear = this.endYear.value
            },
            switchPage(archive) {
                this.archives = archive
                if (this.archives) {
                    this.initYears()
                } else {
                    this.$delete(this.form, 'startYear')
                    this.$delete(this.form, 'endYear')
                }
                this.form.page = 1
                this.formSubmit()

            }
        },
        created() {
            if (this.archives) {
                this.initYears()
            }
            this.animDelta = 100
        },
        mounted() {
            this.formSubmit()
        },
        destroyed() {
        }
    };
</script>
